import { CityLicense } from "@/@types/app/CityLicense";
import { appApi } from "../api";
import { LicenseEnum } from "@/utils/enums/LicenseEnum";
import { ModuleEnum } from "@/utils/enums/ModuleEnum";

type RequestCityLicenseParams = {
	module: ModuleEnum;
	uf: string;
	ibgeCode: string;
	locale: string;
	identifier: string;
	licenseId?: number;
	roleId?: number;
};

export async function requestCityLicense({ licenseId, ...params }: RequestCityLicenseParams) {
	const response = await appApi.post("/cityLicense", {
		licenseId: licenseId || LicenseEnum.ESUS_TEMPORARY,
		...params,
	});
	return response.status === 200;
}

export async function getCityLicensesByCity(ibgeCode: string, module?: ModuleEnum) {
	const { data } = await appApi.get<CityLicense[]>("/CityLicense", { ibgeCode, module });
	return data || [];
}

export async function invalidateCityLicense(ibgeCode: string, module?: ModuleEnum) {
	const response = await appApi.post("/CityLicense/Invalidate", { ibgeCode, module });
	return response.status === 200;
}

export async function acceptCityLicense(ibgeCode: string, module?: ModuleEnum) {
	const response = await appApi.post("/CityLicense/Activate", { ibgeCode, module });
	return response.status === 200;
}

export async function rejectCityLicense(ibgeCode: string, module?: ModuleEnum) {
	const response = await appApi.post("/CityLicense/Reject", { ibgeCode, module });
	return response.status === 200;
}
